import EditQuestion from './EditQuestion.component';

export default EditQuestion;
